<section class="py-4">

  <div *ngIf="tableLoading" class="mx-2 my-4 mx-lg-4 card">
    <div class="p-5 d-flex justify-content-center position-relative">
      <i class="mdi mdi-loading rotate-animation f-80 text-primary"></i>
    </div>
  </div>

  <div *ngIf="!tableLoading && !lote" class="mx-2 my-4 mx-lg-4 card">
    <div  class="p-5 fw-500 text-center text-muted">
      <span>Registro não encontrado</span>
    </div>
  </div>  

  <div *ngIf="!tableLoading && lote" class="mx-2 my-4 mx-lg-4 card">
    <div class="card-header bg-white row justify-content-between align-items-center">
      <h2 class="col-12 col-sm-5 col-md-7 pb-2 px-0 pb-sm-0">
        Lote - {{lote.nome}}
      </h2>
      <div class="d-flex p-0 col-12 col-sm-7 col-md-5">
        <button (click)="download(lote)" class="btn btn-sm flex-fill btn-icon btn-primary">
          <i class="mdi mdi-download"></i>
          <span>Download</span>
        </button>
        <button *ngIf="(lote?.qtdPendente>0) || (lote?.qtdFinalizado < lote?.qtdProcessado)" (click)="atualizar()" class="mx-1 btn btn-sm flex-fill btn-icon btn-info">
          <i class="mdi mdi-refresh"></i>
          <span>Atualizar</span>
        </button>
        <button *ngIf="(lote?.qtdPendente>0) || (lote?.qtdFinalizado < lote?.qtdProcessado)" (click)="executar()" class="btn btn-sm flex-fill btn-icon btn-success">
          <i class="mdi mdi-flash"></i>
          <span>Executar</span>
        </button>
      </div>
    </div>
    <table class="table table-striped table-hover table-responsive-sm">
      <thead>
        <tr>
          <th width="50%" [tableOrderGroup]="params.sorting" [(tableOrder)]="params.sorting.entrada" (tableOrderChange)="changeOrder()">{{lote.labelEntrada}}</th>
          <th width="50%" [tableOrderGroup]="params.sorting" [(tableOrder)]="params.sorting.dataConsulta" (tableOrderChange)="changeOrder()">Data Consulta</th>
          <th width="90px" [tableOrderGroup]="params.sorting" [(tableOrder)]="params.sorting.status" (tableOrderChange)="changeOrder()">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="lote?.lista.length==0">
          <td class="text-center py-5 text-secondary w-500" colspan="8">
            Sem registros
          </td>
        </tr>
        <tr *ngFor="let r of lote?.lista">
          <td>{{r.entrada}}</td>
          <td>{{r.dataConsulta || r.dataConsula}}</td>
          <td>
            <div class="rounded text-center text-white fw-500 f-12 px-1" 
            [ngClass]="{
              'bg-danger': r.status.toLowerCase() == 'erro', 
              'bg-success': r.status.toLowerCase() == 'ok',
              'bg-info': r.status.toLowerCase() == 'na fila',
              'bg-warning': r.status.toLowerCase() == 'pendente',
              'bg-primary': r.status.toLowerCase() == 'sem registro'
            }">
              {{r.status}}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="card-footer bg-white row justify-content-between">
      <div class="pb-2 pb-sm-0">
        <ngb-pagination [pageSize]="params.per_page" [boundaryLinks]="true" [collectionSize]="total" [(page)]="params.page" (pageChange)="nextPage()" [maxSize]="5" [rotate]="true">
        </ngb-pagination>
      </div>
      <div class="pb-2 pb-sm-0">
        <div class="btn-group" role="group">
          <button [disabled]="total==0" (click)="setPageSize(10)" [ngClass]="{'active':  params.per_page==10}" type="button" class="btn btn-outline-primary">10</button>
          <button [disabled]="total==0" (click)="setPageSize(25)" [ngClass]="{'active':  params.per_page==25}" type="button" class="btn btn-outline-primary">25</button>
          <button [disabled]="total==0" (click)="setPageSize(50)" [ngClass]="{'active':  params.per_page==50}" type="button" class="btn btn-outline-primary">50</button>
          <button [disabled]="total==0" (click)="setPageSize(100)" [ngClass]="{'active': params.per_page==100}" type="button" class="btn btn-outline-primary">100</button>
        </div>
      </div>
    </div>
  </div>

</section>